import React, { Component } from "react";
import PropTypes from "prop-types";
import constants from "../../utils/constants";

class TripAdvisorPixel extends Component {
  constructor(props) {
    super(props);
    this.state = { accountId: "001F000000ukweA" };
  }

  componentDidMount() {
    if (
      typeof TAPixel === "object" &&
      TAPixel !== null &&
      this.props.currentStep !== constants.STEP_PATHS.STEP_3
    ) {
      try {
        TAPixel.impressionWithReferer(this.state.accountId); // eslint-disable-line
      } catch (exception) {
        console.log(exception);
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { externalConfiguration, externalReservation, reservationCreated } = this.props;

    if (
      (prevProps.currentStep !== this.props.currentStep ||
        prevProps.reservationCreated !== reservationCreated ||
        prevProps.externalConfiguration !== externalConfiguration ||
        prevProps.externalReservation !== externalReservation) &&
      TAPixel !== null &&
      typeof TAPixel === "object" && // eslint-disable-line
      this.props.currentStep === constants.STEP_PATHS.STEP_3 &&
      reservationCreated &&
      externalConfiguration &&
      externalReservation &&
      externalReservation.status === constants.RESERVATION_STATUS.CONFIRMED
    ) {
      externalReservation.items.map(roomStay => {
        const partnerId = externalConfiguration.establishment;
        const gvd = (roomStay.amount * 100).toFixed(0);
        const currency = externalConfiguration.currency;
        const taxPaid = 0;
        const feesPaid = 0;
        const startDate = roomStay.checkIn;
        const endDate = roomStay.checkOut;
        const numAdults = roomStay.people;
        const orderConfirmation = roomStay.id;

        try {
          TAPixel.conversionWithReferer(
            this.state.accountId,
            partnerId,
            gvd,
            currency,
            taxPaid,
            feesPaid,
            startDate,
            endDate,
            numAdults,
            orderConfirmation
          ); // eslint-disable-line
        } catch (exception) {
          console.log(exception);
        }
      });

      if (!this.props.isLoaded) {
        this.props.loaded();
      }
    }
  }

  render() {
    return <div />;
  }
}

TripAdvisorPixel.propTypes = {
  isLoaded: PropTypes.bool,
};

export default TripAdvisorPixel;
